// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16WDu","input":"styles_input__2ZC-1"};